import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: calc(100vw - 4rem);
  min-height: 85vh;
  padding: 0 2rem 2rem 2rem;
  .boards-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 1rem;
    .board-card {
      display: flex;
      flex-direction: column;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid lightgray;
      border-radius: 25px;
      width: calc(46% - 2rem);
      padding: 1rem;
      margin: 0;
      height: auto;
      position: relative;
      .options-container {
        position: absolute;
        top: 0;
        right: 1rem;
        font-weight: 700;
        z-index: 9;
        cursor: pointer;
        text-align: right;
        border-radius: 24px;
        .menu {
          font-size: 30px;
          margin: 0;
          color: #000;
        }
        .options {
          margin: 0;
          list-style: none;
          text-align: left;
          flex-direction: column;
          border: 1px solid #ed4242;
          border-radius: 24px;
          padding: 1rem;
          color: #000;
          background: #fff;
          visibility: hidden;
          opacity: 0;
          transition: visibility 200ms, opacity 200ms, display 200ms;
          .delete {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
              color: red;
            }
            img {
              width: 20px;
            }
          }
          .edit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 20px;
            }
          }
          &.active {
            display: flex;
            visibility: visible;
            opacity: 1;
            transition: visibility 200ms, opacity 200ms, display 200ms;
          }
          li {
            font-size: 16px;
            a {
              text-decoration: none;
              color: #000;
            }
          }
        }
      }
      .title {
        flex: 1;
        min-height: 25px;
      }
      .description {
        flex: 1;
        min-height: 40px;
      }
      a {
        width: fit-content;
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .boards-container
      .board-card
      .options-container
      .options
      .delete
      .trash-can-button {
      width: 20px;
    }
    .boards-container .board-card {
      width: calc(22% - 2rem);
      margin: 0;
    }
  }
`;
